import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../Components/Hooks/UserHooks";

const Navdata = () => {
    const history = useNavigate();
    const { isAdmin } = useProfile();
    //state data
    const [isDashboard, setIsDashboard] = useState<boolean>(false);
    const [isUsers, setIsUsers] = useState<boolean>(false)
    const [isCustomers, setIsCustomers] = useState<boolean>(false)
    const [isContacts, setIsContacts] = useState<boolean>(false);
    const [isApps, setIsApps] = useState<boolean>(false);
    const [isAuth, setIsAuth] = useState<boolean>(false);
    const [isPages, setIsPages] = useState<boolean>(false);
    const [isBaseUi, setIsBaseUi] = useState<boolean>(false);
    const [isAdvanceUi, setIsAdvanceUi] = useState<boolean>(false);
    const [isForms, setIsForms] = useState<boolean>(false);
    const [isTables, setIsTables] = useState<boolean>(false);
    const [isCharts, setIsCharts] = useState<boolean>(false);
    const [isIcons, setIsIcons] = useState<boolean>(false);
    const [isMaps, setIsMaps] = useState<boolean>(false);
    const [isMultiLevel, setIsMultiLevel] = useState<boolean>(false);


    const [iscurrentState, setIscurrentState] = useState('Dashboard');

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems: any = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement;
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    useEffect(() => {

        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        // if (iscurrentState !== 'Catalogs') {
        //     setIsCatalogs(false);
        // }

        if (iscurrentState !== 'Users') {
            setIsUsers(false);
        }
        if (iscurrentState !== 'Customers') {
            setIsCustomers(false);
        }

        if (iscurrentState !== 'Contacto') {
            setIsContacts(false);
        }
        if (iscurrentState !== 'Apps') {
            setIsApps(false);
        }
        if (iscurrentState !== 'Auth') {
            setIsAuth(false);
        }
        if (iscurrentState !== 'Pages') {
            setIsPages(false);
        }
        if (iscurrentState !== 'BaseUi') {
            setIsBaseUi(false);
        }
        if (iscurrentState !== 'AdvanceUi') {
            setIsAdvanceUi(false);
        }
        if (iscurrentState !== 'Forms') {
            setIsForms(false);
        }
        if (iscurrentState !== 'Tables') {
            setIsTables(false);
        }
        if (iscurrentState !== 'Charts') {
            setIsCharts(false);
        }
        if (iscurrentState !== 'Icons') {
            setIsIcons(false);
        }
        if (iscurrentState !== 'Maps') {
            setIsMaps(false);
        }
        if (iscurrentState !== 'MuliLevel') {
            setIsMultiLevel(false);
        }
        if (iscurrentState === 'Widgets') {
            history("/widgets");
            document.body.classList.add('twocolumn-panel');
        }
    }, [
        history,
        iscurrentState,
        isDashboard,
        isApps,
        isAuth,
        isCustomers,
        isPages,
        isBaseUi,
        isAdvanceUi,
        isForms,
        isTables,
        isCharts,
        isIcons,
        isMaps,
        isMultiLevel,
        isContacts,


    ]);

    const menuItems: any = [
        ...(isAdmin ? [
            {
                label: "Administrador",
                isHeader: true,
            },
            {
                id: "customers",
                label: "Clientes",
                icon: "ri-group-line",
                link: "/#",
                stateVariables: isCustomers,
                click: function (e: any) {
                    e.preventDefault();
                    setIsCustomers(!isCustomers);
                    setIscurrentState('Customers');
                    updateIconSidebar(e);
                },
                subItems: [
                    {
                        id: "customers_list",
                        label: "Ver Clientes",
                        link: "/customers",
                        parentId: "customers"
                    },
                    {
                        id: "customer_states",
                        label: "Estados de clientes",
                        link: "/customer-states",
                        parentId: "customers"
                    },
                ],
            },
            {
                id: "users",
                label: "Gestión de usuarios",
                icon: "ri-user-3-line",
                link: "/#",
                stateVariables: isUsers,
                click: function (e: any) {
                    e.preventDefault();
                    setIsUsers(!isUsers);
                    setIscurrentState('Users');
                    updateIconSidebar(e);
                },
                subItems: [
                    {
                        id: "roles",
                        label: "Roles",
                        link: "/roles",
                        parentId: "users"
                    },
                    {
                        id: "user",
                        label: "Usuarios",
                        link: "/users",
                        parentId: "users"
                    },
                ],
            }
        ] : []),
        {
            id: "whatsapp",
            label: "Whatsapp",
            icon: "ri-whatsapp-line",
            link: "/whatsapp",
            stateVariables: false, // State manages itself via React Router active link basically, or you could add isWhatsapp to Navdata state, but for simple links it's often fine to just pass click handler that sets state. Let's add it properly.
            click: function (e: any) {
                e.preventDefault();
                setIscurrentState('Whatsapp');
                updateIconSidebar(e);
                history("/whatsapp"); // need to navigate
            },
        },

    ];
    return <React.Fragment>{menuItems}</React.Fragment>;
}
    ;
export default Navdata;
